import type { RolePreset } from './types';

/** Capability keys mirror BusinessCapability in vuelto-negocio. */
export type PresetFilterCapability =
  | 'tables'
  | 'kitchen_tickets'
  | 'appointments'
  | 'pos';

/**
 * Filtra presets por capability del rubro. Los presets específicos de hospitalidad/servicios
 * se ocultan si el rubro no tiene la capability correspondiente.
 */
export function filterPresetsByCapabilities(
  presets: RolePreset[],
  capabilities: Set<string>
): RolePreset[] {
  return presets.filter((preset) => {
    if (preset.id === 'waiter' && !capabilities.has('tables')) return false;
    if (preset.id === 'kitchen' && !capabilities.has('kitchen_tickets')) return false;
    if (
      preset.id === 'mostrador' &&
      !capabilities.has('kitchen_tickets') &&
      !capabilities.has('pos')
    ) {
      return false;
    }
    if (preset.id === 'agenda-staff' && !capabilities.has('appointments')) return false;
    if (preset.id === 'receptionist' && !capabilities.has('appointments')) return false;
    return true;
  });
}
